import { ResourceDetail } from '@cibo/core'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { useEffect, useState } from 'react'
import { TraitCellEditorProps } from '../types'

const answerFromDetail = (detail?: ResourceDetail) => {
  return detail?.result === undefined ? '' : detail?.result ? 'yes' : 'no'
}

export const CoverCropCellEditor = ({
  traitId,
  year,
  params,
  t,
  saveDetail,
  removeDetail,
}: TraitCellEditorProps) => {
  const detail = params.row.resolveStandingDetail(traitId, year)
  const [answer, setAnswer] = useState(answerFromDetail(detail))

  useEffect(() => {
    setAnswer(answerFromDetail(detail))
  }, [detail])

  const handleChangeCrop = (event: SelectChangeEvent) => {
    const { value } = event.target

    setAnswer(value)

    if (value === '') {
      removeDetail({
        resourceId: params.row.resourceId,
        traitId,
        year,
      })
    } else {
      saveDetail({
        resourceId: params.row.resourceId,
        details: [{ traitId, year, result: value === 'yes' }],
      })
    }
  }

  const source = detail?.source

  return (
    <Select value={answer} onChange={handleChangeCrop} fullWidth data-testid={`cover_crop_editor`}>
      {source === 'user' && <MenuItem value={''}>{`${t('remove')}`}</MenuItem>}

      <MenuItem value={'yes'}>{`${t('yes')}`}</MenuItem>

      <MenuItem value={'no'}>{`${t('no')}`}</MenuItem>
    </Select>
  )
}
